module.exports = __webpack_public_path__ + "static/media/web-logo-orange.b509634e.svg";